import React from 'react';
import { Container, Typography, Button } from '@mui/material';
import './MusicStreamingFirstSection.scss';
import UnifiedButton from '../../shared/Button';
import { useNavigate } from 'react-router-dom';

const MusicStreamingFirstSection = () => {
    const navigate = useNavigate()
    const handleJoinNow = () => {
        window.scrollTo(0, 0);
        navigate('/pricing/2');
    };

    return (
        <section className="music-streaming-section">
            <Container className="content-container">
                <Typography variant="h2" className="section-title">
                    Music Streaming <br /> & Distribution Stores
                </Typography>
                <Typography variant="body1" className="section-description">
                    FM Digital Official Music Distribution places your music in the most popular digital stores worldwide, including Spotify, Apple Music, iTunes, Amazon Music, and more. We partner with over 190+ digital platforms, and here are just a few of our top store partners.
                </Typography>
                <UnifiedButton variant="contained" className="join-button" onClick={handleJoinNow} textContent={"Join Now"} />


            </Container>
        </section>
    );
};

export default MusicStreamingFirstSection;
